import React from "react";

import Header from "./components/Header";
import Stats from "./components/Stats";
import NFT from "./components/NFT";
import Gallery from "./components/Gallery";
import Tshirt from "./components/Tshirt";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      //
    };
  }

  render() {
    return (
      <>
        <Header />
        <Stats />
        <NFT />
        <Gallery />
        <Tshirt />
        <footer>Copyright © Nobel Actus Lda e SUMOL+COMPAL S.A. 2022. All rights reserved</footer>
      </>
    );
  }
}

export default App;
